import en from 'date-format-parse/es/locale/en.js';
<template>
    <div
        ref="backdropTop"
        :class="{ fixed: visible, hidden: !visible }"
        class="hts-global-backdrop-top top-0 left-0 w-screen"
        @click="handleClick" />
    <div
        ref="backdropLeft"
        :class="{ fixed: visible, hidden: !visible }"
        class="hts-global-backdrop-left left-0"
        @click="handleClick" />
    <div
        ref="backdropRight"
        :class="{ fixed: visible, hidden: !visible }"
        class="hts-global-backdrop-right right-0 w-[5000px]"
        @click="handleClick" />
    <div
        ref="backdropBottom"
        :class="{ fixed: visible, hidden: !visible }"
        class="hts-global-backdrop-bottom left-0 w-screen h-[5000px]"
        @click="handleClick" />
    <div
        ref="backdropAlert"
        :class="{ fixed: alertVisible, hidden: !alertVisible }"
        class="hts-global-backdrop-alert"
        :style="alertStyle">
        <div
            class="hts-global-backdrop-alert__content"
            v-html="alertContent" />
        <div class="hts-global-backdrop-alert__footer">
            <hts-form-button
                v-if="alertCloseButtonText"
                color="info"
                type="button"
                :outline="false"
                class="hts-global-backdrop-alert__close-btn"
                @click="handleClickAlertCloseButton">
                {{ alertCloseButtonText }}
            </hts-form-button>
        </div>
    </div>
</template>

<script lang="ts" setup>
const { $eventBus } = useNuxtApp()
const backdropTop: any = ref(null)
const backdropLeft: any = ref(null)
const backdropRight: any = ref(null)
const backdropBottom: any = ref(null)
const closeEnable = ref(true)
const visible = ref(false)
const target: any = ref(null)
const alertVisible = ref<boolean>(false)
const alertContent = ref<string>('')
const alertCloseButtonText = ref<string>('')
const alertRoute = ref<any>({})
const alertAction = ref<any>(null)
const alertStyle = reactive({
  top: 0,
  left: 0,
  width: '600px',
  height: '180px',
  backgroundColor: '#FFF',
  color: '#333'
})

onBeforeMount(() => {
  $eventBus.on('global-backdrop-show', show)
  $eventBus.on('global-backdrop-hide', forceHide)
  $eventBus.on('global-backdrop-alert-show', showAlert)
  $eventBus.on('global-backdrop-alert-hide', hideAlert)
  if (process.client) {
    window?.addEventListener('resize', handleResize)
  }
})
onBeforeUnmount(() => {
  if (process.client) {
    window?.removeEventListener('resize', handleResize)
  }
})

const show = ({ target, options }: any) => {
  if (!target) {
    return
  }
  if (options?.closeable !== undefined) {
    closeEnable.value = !!options.closeable
  } else {
    closeEnable.value = true
  }
  target.value = target
  const rect = target.getBoundingClientRect()
  const { bottom, height, left, right, top, width } = rect

  setTop(top)
  setBottom(bottom)
  setLeft(top, left, height)
  setRight(top, right, height)
  nextTick(() => {
    visible.value = true
  })
}
const forceHide = () => {
  hide(true)
}
const hide = (force: boolean = false) => {
  if (!closeEnable.value && !force) {
    return
  }
  target.value = null
  visible.value = false
  alertVisible.value = false
  closeEnable.value = true
}
const setTop = (height: number) => {
  if (!backdropTop.value) {
    return
  }
  backdropTop.value.style.height = `${height}px`
}
const setBottom = (height: number) => {
  if (!backdropBottom.value) {
    return
  }
  backdropBottom.value.style.top = `${height}px`
}
const setLeft = (top: number, width: number, height: number) => {
  if (!backdropLeft.value) {
    return
  }
  backdropLeft.value.style.top = `${top}px`
  backdropLeft.value.style.width = `${width}px`
  backdropLeft.value.style.height = `${height}px`
}
const setRight = (top: number, right: number, height: number) => {
  if (!backdropRight.value) {
    return
  }
  backdropRight.value.style.top = `${top}px`
  backdropRight.value.style.right = `${right}px`
  backdropRight.value.style.height = `${height}px`
}
const handleClick = (e: any) => {
  hide()
}
const handleResize = () => {
  if (!target.value || !visible.value) {
    return
  }
  if (alertVisible.value) {
    return updateAlertPosition()
  }
  show(target.value)
}

const showAlert = ({ content, style, closeable, route, closeButtonText, action }: any) => {
  alertContent.value = content
  if (closeable !== undefined) {
    closeEnable.value = !!closeable
  } else {
    closeEnable.value = false
  }
  if (typeof style === 'object') {
    Object.assign(alertStyle, style)
  }
  if (closeButtonText) {
    alertCloseButtonText.value = closeButtonText
  }
  if (route) {
    alertRoute.value = route
  }
  if (action) {
    alertAction.value = action
  }
  setTop(window.innerHeight)
  Object.assign(alertStyle, {
    top: window.innerHeight / 2 - 180 / 2 + 'px',
    left: window.innerWidth / 2 - 600 / 2 + 'px'
  })
  nextTick(() => {
    alertVisible.value = true
    visible.value = true
  })
}

const updateAlertPosition = () => {
  setTop(window.innerHeight)
  Object.assign(alertStyle, {
    top: window.innerHeight / 2 - 180 / 2 + 'px',
    left: window.innerWidth / 2 - 600 / 2 + 'px'
  })
}

const hideAlert = () => {
  hide(true)
}

const handleClickAlertCloseButton = (e: any) => {
  hide(true)
  if (alertRoute.value) {
    useRouter().push(alertRoute.value)
  }
  if (alertAction.value && typeof alertAction.value === 'function') {
    alertAction.value()
  }
}
</script>
